<template>
    <div class="h-100">
        <nav class="navbar navbar-expand-lg p-0">
            <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
                <div class="navbar-nav w-100 top-nav-bar">
                    <!-- <a class="nav-item nav-link w-50" v-if="isEnabled('manage-catalogs')" v-on:click="changeComponent('catalogs-info');" :class='{active: activeIndex === "catalogs-info"}' style="width:15% !important">Catalogs<span class="sr-only">(current)</span></a> -->
                    <!-- <a class="nav-item nav-link w-50" v-if="isEnabled('manage-tags')" v-on:click="changeComponent('tags-info'); " :class='{active: activeIndex === "tags-info"}' style="width:15% !important">Tags</a> -->
                </div>
            </div>
        </nav>
        <!-- <show-catalogs v-show="activeIndex == 'catalogs-info'"></show-catalogs> -->
        <!-- <show-tags v-show="activeIndex == 'tags-info'"></show-tags> -->
        <show-tags v-show="activeIndex == 'tags-info'"></show-tags>
    </div>
</template>

<script>
import TagsList from "../tags/Tags.vue"
import Utils from "../../components.utils.js"
import {mapGetters} from "vuex"

export default {
    data(){
        return{
            activeIndex:"tags-info"
            //activeIndex: ""
        }
    },
    components: {
        "show-tags": TagsList,
        // "show-catalogs": CatalogList
    },
    methods:{
        changeComponent(comp){
          this.activeIndex = comp
        },
        isEnabled(priv){
            let isPrivEnabled = Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege(),priv);
            if(this.activeIndex == "" || typeof this.activeIndex =="undefined"){
                // if(priv == "manage-catalogs" && isPrivEnabled){
                //     this.activeIndex = "catalogs-info";
                //     return true;
                // }
                if(priv == "manage-tags" && isPrivEnabled){
                    this.activeIndex = "tags-info"
                    return true;
                }
            }
            return isPrivEnabled
        },
      ...mapGetters("users",["getLoggedInUserPrivilege"])
    }
}
</script>

<style scoped lang="scss">
$active-blue: #007bff;
$options-text-color: #9c9c9c;
$text-color: #eee;
$body-bg-color: #141414;
$white-text: #fff;
$header-background: #181818;

.nav-item{
    color: $options-text-color !important;
}

.active{
    background: $body-bg-color !important;
    color: #eee!important;
    font-weight: 500;
    font-size:15px;
}
.top-nav-bar{
    background: $header-background;
}


</style>